export default __webpack_public_path__ + "static/media/Siempre-a-tu-lado.95b749e7.svg";